import React from 'react';
import LocalOpsSheet from './LocalOpsSheet';

export const STARTER_TASK_TEMPLATES = Object.freeze([
  {
    id: 'food_pickup',
    label: 'Food pickup',
    type: 'task_errand',
    category: 'Errands',
    title: 'Pick up food order',
    description:
      'Pick up my food order and bring it to me.\n\nDetails:\n- Restaurant:\n- Pickup time:\n- Order name:\n- Drop-off notes:',
  },
  {
    id: 'grocery_pickup',
    label: 'Grocery pickup',
    type: 'task_errand',
    category: 'Errands',
    title: 'Pick up groceries',
    description:
      'Pick up a grocery order and bring it to me.\n\nDetails:\n- Store:\n- Pickup time:\n- Order name:\n- Drop-off notes:',
  },
  {
    id: 'small_errand',
    label: 'Small errand',
    type: 'task_errand',
    category: 'Errands',
    title: 'Help with a small errand',
    description:
      'I need help with a small local errand.\n\nDetails:\n- What needs done:\n- Pickup/drop-off notes:\n- Best time:\n- Any special instructions:',
  },
  {
    id: 'home_help',
    label: 'Home Help',
    type: 'task_home_help',
    category: 'Home',
    title: 'Help with a small home task',
    description:
      'I need help with a small home/property task.\n\nDetails:\n- What needs done:\n- Tools/materials needed:\n- Best time:\n- Any notes:',
  },
  {
    id: 'cleaning_help',
    label: 'Cleaning',
    type: 'task_home_help',
    category: 'Home',
    title: 'Help with cleaning',
    description:
      'I need help with a cleaning task.\n\nDetails:\n- Area to clean:\n- Estimated time:\n- Supplies provided:\n- Best time:',
  },
  {
    id: 'yard_help',
    label: 'Yard help',
    type: 'task_home_help',
    category: 'Home',
    title: 'Help with yard work',
    description:
      'I need help with a small yard/property task.\n\nDetails:\n- What needs done:\n- Tools/materials needed:\n- Best time:\n- Any notes:',
  },
  {
    id: 'posting_help',
    label: 'Posting help',
    type: 'task_errand',
    category: 'Errands',
    title: 'Help with a local posting task',
    description:
      'I need help with a simple online/local posting task.\n\nDetails:\n- What needs posted:\n- Where it should be posted:\n- Any wording or screenshot needed:\n- Completion proof:',
  },
]);

export const buildStarterTaskPreset = (template) => {
  if (!template?.type) return null;
  return {
    type: template.type,
    title: template.title,
    description: template.description,
    category: template.category,
  };
};

export default function LocalOpsStarterTaskIdeas({
  open,
  onClose,
  onSelect,
}) {
  if (!open) return null;

  const handleSelect = (template) => {
    onSelect?.(buildStarterTaskPreset(template), template);
  };

  return (
    <LocalOpsSheet
      open={open}
      onClose={onClose}
      title="Starter task ideas"
      ariaLabel="Starter task ideas"
      className="localops-starter-sheet"
    >
      <div className="localops-starter">
        <p className="localops-starter__intro">
          Start small with something useful: a pickup, errand, cleaning help,
          home help, or food run.
        </p>
        <div className="localops-starter__budget">
          Many simple starter tasks are posted around $5-$20 depending on
          distance, time, and effort. Offer more for driving, heavy work, tools,
          waiting, urgent timing, or longer distance.
        </div>
        <div className="localops-starter__grid">
          {STARTER_TASK_TEMPLATES.map((template) => (
            <button
              type="button"
              className="localops-starter-card"
              key={template.id}
              onClick={() => handleSelect(template)}
            >
              <span>{template.label}</span>
              <small>{template.title}</small>
            </button>
          ))}
        </div>
        <button
          type="button"
          className="localops-starter-custom"
          onClick={() => onSelect?.(null, { id: 'custom_task' })}
        >
          Custom local task
        </button>
      </div>
    </LocalOpsSheet>
  );
}
